//$ = window.jQuery;

window.jQuery(document).ready(function () {

    window.$MWGmap = window.jQuery('#map');

    if (window.$MWGmap.length > 0) {
        window.jQuery('#geolocate-address').html('<i class="fi-map"></i>&nbsp;' + window.jQuery('#geolocate-address').text());

        var style = [
            {
                stylers: [
                    {saturation: '-100'},
                    {lightness: '20'}
                ]
            }, {
                featureType: 'poi',
                stylers: [
                    {visibility: 'off'}
                ]
            }, {
                featureType: 'transit',
                stylers: [
                    {visibility: 'off'}
                ]
            }, {
                featureType: 'road',
                stylers: [
                    {lightness: '50'},
                    {visibility: 'on'}
                ]
            }, {
                featureType: 'landscape',
                stylers: [
                    {lightness: '50'}
                ]
            }
        ];

        var mwLatLng = new google.maps.LatLng(47.1889911, 8.4842160);
        var image = window.mapMarker;
        var options = {
            zoom: 14,
            center: mwLatLng,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            disableDefaultUI: false
        };

        var gMap = new google.maps.Map(window.$MWGmap[0], options);
        var infowindow = new google.maps.InfoWindow({
            content: '<div></div>',
            pixelOffset: new google.maps.Size(0, -40)
        });
        infowindow.setContent(window.jQuery('#infoWindowContent').html());
        var marker = new google.maps.Marker({
            position: mwLatLng,
            map: gMap,
            title: 'DocWorld AG',
            icon: image
        });

        infowindow.open(gMap, marker);

        gMap.setOptions({
            styles: style
        });

        gMap.setCenter(marker.getPosition());
        gMap.panBy(-120, -120);

        var addressField = window.jQuery('input[name="direction-address"]');
        var directionsPanel = window.jQuery('#directionsPanel');
        var directionsDisplay = new google.maps.DirectionsRenderer();
        directionsDisplay.setMap(gMap);
        directionsDisplay.setPanel(document.getElementById('directionsPanel'));

        var $locateButton = window.jQuery('#geolocate-address');
        var $addressButton = window.jQuery('#route-address');

        $locateButton.on('click', function (e) {
            $locateButton.addClass('oc-loading');
            e.preventDefault();
            locateAddress(e, null)
        });
        $addressButton.on('click', function (e) {
            $addressButton.addClass('oc-loading');
            e.preventDefault();
            locateAddress(e, addressField.val())
        });

        window.$MWGmap.on('locationFound', function (e, pos) {
            $locateButton.removeClass('oc-loading');
            $addressButton.removeClass('oc-loading');
            showDirections(e, pos, directionsDisplay, directionsPanel);
        });
    }

})

/**** directions **/

function locateAddress (e, address) {
    if (!address) {
        // Try HTML5 geolocation
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function (position) {
                var start = new google.maps.LatLng(position.coords.latitude,
                    position.coords.longitude);
                window.$MWGmap.trigger('locationFound', [start]);
            }, function () {
                handleNoGeolocation(true);
            });
        } else {
            // Browser doesn't support Geolocation
            handleNoGeolocation(false);
        }
    } else {
        var geocoder = new google.maps.Geocoder();
        geocoder.geocode({'address': address}, function (results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
                var start = new google.maps.LatLng(results[0].geometry.location.lat(), results[0].geometry.location.lng());
                window.$MWGmap.trigger('locationFound', [start]);
            }
        });
    }
}

function handleNoGeolocation (addressNotFound) {
    if (addressNotFound) {
        alert('We could not locate your address. Please check your input.');
    } else {
        alert('Sorry, your browser does not support GeoLocation or you did not give the website permission to access your location. Please reload the page.');
    }
}

function showDirections (e, pos, directionsDisplay, directionsPanel) {
    var directionsService = new google.maps.DirectionsService();
    var start = pos;
    var end = 'Sennweidstrasse 46, 6312 Steinhausen, Schweiz';
    var request = {
        origin: start,
        destination: end,
        travelMode: google.maps.TravelMode.DRIVING
    };
    directionsService.route(request, function (response, status) {
        if (status == google.maps.DirectionsStatus.OK) {
            directionsDisplay.setDirections(response);
            directionsPanel.addClass('show');
        }
    });
}
